import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=d5a766fc&scoped=true"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=d5a766fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a766fc",
  null
  
)

export default component.exports